(() => {
  const roots = document.querySelectorAll('[data-fs-information]');

  roots.forEach((root) => {
    const kind = root.dataset.fsKind;

    if (kind === 'shipping') {
      const search = root.querySelector('[data-fs-shipping-search]');
      const country = root.querySelector('[data-fs-shipping-country]');
      const status = root.querySelector('[data-fs-shipping-status]');
      if (!search || !country || !status) return;
      const options = [...country.options].slice(1);
      const update = () => {
        const query = search.value.trim().toLocaleLowerCase();
        let visible = 0;
        options.forEach((option) => {
          const matches = !query || option.textContent.toLocaleLowerCase().includes(query);
          option.hidden = !matches;
          if (matches) visible += 1;
        });
        const destinationLabel = visible === 1 ? root.dataset.fsShippingDestinationSingular : root.dataset.fsShippingDestinationPlural;
        status.textContent = query ? `${visible} ${destinationLabel}` : root.dataset.fsShippingStatusDefault;
      };

      const updateSelected = () => {
        status.textContent = country.value ? root.dataset.fsShippingStatusSelected : root.dataset.fsShippingStatusDefault;
      };

      search.addEventListener('input', update);
      country.addEventListener('change', updateSelected);
      update();
    }

    if (kind === 'reports') {
      const search = root.querySelector('[data-fs-report-search]');
      const status = root.querySelector('[data-fs-report-status]');
      const clear = root.querySelector('[data-fs-report-clear]');
      const empty = root.querySelector('[data-fs-report-empty]');
      const outline = root.querySelector('[data-fs-outline-nav]');
      if (!search || !status) return;

      const normalise = (value) => value.replace(/(\d)[,\u00a0\u202f ](?=\d{3}(?:\D|$))/g, '$1').normalize('NFD').replace(/\p{M}/gu, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}.%]+/gu, ' ').trim();
      const links = [...root.querySelectorAll('[data-fs-information-content] a[href]')].filter((link) => /\.pdf(?:[?#]|$)/i.test(link.href));
      const grouped = new Map();
      links.forEach((link) => {
        const container = link.closest('li') || link.closest('p') || link.parentElement || link;
        const current = grouped.get(container) || [];
        current.push(link);
        grouped.set(container, current);
      });
      const items = [...grouped.entries()].map(([container, itemLinks]) => {
        const card = container.closest('.fs-coa__card');
        const section = container.closest('.fs-coa__section');
        const headings = [card?.querySelector('h3')?.textContent, section?.querySelector('h2')?.textContent];
        const searchable = itemLinks.map((link) => {
          let filename = '';
          try { filename = decodeURIComponent(new URL(link.href).pathname.split('/').pop()); } catch {}
          return normalise([link.textContent, ...headings, filename].filter(Boolean).join(' '));
        });
        return { container, itemLinks, searchable, groups: [card, section].filter(Boolean), matches: true };
      });
      const groups = [...new Set(items.flatMap((item) => item.groups))];

      const update = () => {
        const query = normalise(search.value);
        const terms = query.split(/\s+/).filter(Boolean);
        let visible = 0;

        items.forEach((item) => {
          item.matches = !query || item.searchable.some((text) => terms.every((term) => {
            if (term.endsWith('%')) return text.split(' ').includes(term);
            if (/^\d+(?:\.\d+)?%?$/.test(term) && (term.endsWith('%') || Number(term) <= 100)) return text.split(' ').some((word) => word.replace(/%$/, '') === term.replace(/%$/, ''));
            return text.includes(term);
          }));
          item.container.classList.toggle('fs-information-report-hidden', !item.matches);
          if (item.matches) visible += item.itemLinks.length;
        });
        groups.forEach((group) => group.classList.toggle('fs-information-report-hidden', !items.some((item) => item.matches && item.groups.includes(group))));
        if (clear) clear.hidden = !search.value;
        if (empty) empty.hidden = visible > 0;
        if (outline?.querySelector('a')) outline.hidden = Boolean(query);

        const label = visible === 1 ? root.dataset.fsReportStatusSingular : root.dataset.fsReportStatusPlural;
        status.textContent = `${visible} ${label}`;
      };

      search.addEventListener('input', update);
      clear?.addEventListener('click', () => {
        search.value = '';
        update();
        search.focus();
      });
      update();
    }
  });
})();
